import { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import Modal from './Modal'

/**
 * 「单号 + 手机号后四位」身份校验弹窗。
 *
 * 三处共用：集运报名(ConsolidationPage) / 我的报名(CargoPage) / 我的订单(MyOrdersPage)。
 * 仅凭单号不足以查看单据，必须再对上下单时预留手机号的后四位。
 *
 * 后四位的输入、只留数字、四位格式校验都收在组件内部，父组件只给 visible + code，
 * 并在 onConfirm(phoneTail) 里去查自己的接口 —— 校验成功/失败的提示归父组件，
 * 因为只有它知道查的是什么。
 */
export default function PhoneTailVerifyModal({
  visible,
  code,
  subject = '报名单',
  onConfirm,
  onCancel,
  loading = false,
}) {
  const [phoneTail, setPhoneTail] = useState('')

  // 每次打开都清空，避免上一次没查成功的输入残留
  useEffect(() => {
    if (visible) setPhoneTail('')
  }, [visible])

  const submit = () => {
    if (!/^\d{4}$/.test(phoneTail)) {
      toast.error('请输入手机号后四位')
      return
    }
    onConfirm(phoneTail)
  }

  return (
    <Modal open={visible} onClose={onCancel} title="身份校验">
      <div className="space-y-4">
        <p className="text-sm text-gray-600">
          请输入{subject} <span className="font-semibold text-primary-600">{code}</span> 预留的手机号后四位以查看详情。
        </p>
        <input
          type="text"
          inputMode="numeric"
          maxLength={4}
          className="form-control tracking-widest text-center text-lg"
          placeholder="手机号后四位"
          value={phoneTail}
          onChange={(e) => setPhoneTail(e.target.value.replace(/\D/g, '').slice(0, 4))}
          onKeyDown={(e) => e.key === 'Enter' && submit()}
          autoFocus
        />
        {/* 小屏按钮撑满并上下排：并排时两个 btn 会被挤到只剩几十像素 */}
        <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 sm:gap-3">
          <button className="btn btn-secondary w-full sm:w-auto" type="button" onClick={onCancel}>取消</button>
          <button
            className="btn btn-primary w-full sm:w-auto"
            type="button"
            disabled={loading}
            onClick={submit}
          >{loading ? '校验中...' : '确认'}</button>
        </div>
      </div>
    </Modal>
  )
}
